module.exports = __webpack_public_path__ + "assets/img/more-btn-2b09f38f.png";